var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "simple-loading",
    {
      attrs: {
        "is-loading": _vm.isLoading,
        "is-load-failed": _vm.loadFail,
        showLoadingCard: true,
      },
      on: { reload: _vm.fetchDetail },
    },
    [
      _c(
        "div",
        { staticClass: "card p-2" },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.saveLoading,
                  expression: "saveLoading",
                },
              ],
            },
            [
              _c(
                "el-descriptions",
                {
                  staticClass: "margin-top",
                  attrs: {
                    direction: "vertical",
                    title: "Account Details",
                    column: 3,
                    border: "",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "extra" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.saveDetail },
                        },
                        [_vm._v("Save")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-user" }),
                        _vm._v(" User ID "),
                      ]),
                      _vm._v(" " + _vm._s(_vm.detail.userId) + " "),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-user" }),
                        _vm._v(" Username "),
                      ]),
                      _c(
                        "div",
                        { staticClass: "center" },
                        [
                          _c("avatar", {
                            attrs: { username: _vm.detail.username, size: 24 },
                          }),
                          _vm._v(" " + _vm._s(_vm.detail.username) + " "),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-user" }),
                        _vm._v(" Full Name "),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "Please input fullname" },
                        model: {
                          value: _vm.detail.fullName,
                          callback: function ($$v) {
                            _vm.$set(_vm.detail, "fullName", $$v)
                          },
                          expression: "detail.fullName",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-message" }),
                        _vm._v(" E-mail "),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "Please input email" },
                        model: {
                          value: _vm.detail.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.detail, "email", $$v)
                          },
                          expression: "detail.email",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-position" }),
                        _vm._v(" Phone Area Code "),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "Please input phone area code" },
                        model: {
                          value: _vm.detail.phoneAreaCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.detail, "phoneAreaCode", $$v)
                          },
                          expression: "detail.phoneAreaCode",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-mobile-phone" }),
                        _vm._v(" Phone Number "),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "Please input phone number" },
                        model: {
                          value: _vm.detail.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.detail, "phone", $$v)
                          },
                          expression: "detail.phone",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-office-building" }),
                        _vm._v(" Company "),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "Please input company name" },
                        model: {
                          value: _vm.detail.company,
                          callback: function ($$v) {
                            _vm.$set(_vm.detail, "company", $$v)
                          },
                          expression: "detail.company",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-table-lamp" }),
                        _vm._v(" Department "),
                      ]),
                      _c("el-input", {
                        attrs: { placeholder: "Please input department" },
                        model: {
                          value: _vm.detail.department,
                          callback: function ($$v) {
                            _vm.$set(_vm.detail, "department", $$v)
                          },
                          expression: "detail.department",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-view" }),
                        _vm._v(" Account Enable "),
                      ]),
                      _c("el-switch", {
                        attrs: {
                          "active-text": "Active",
                          "inactive-text": "Inactive",
                        },
                        model: {
                          value: _vm.detail.enable,
                          callback: function ($$v) {
                            _vm.$set(_vm.detail, "enable", $$v)
                          },
                          expression: "detail.enable",
                        },
                      }),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-refresh-right" }),
                        _vm._v(" Login Failed Attempts "),
                      ]),
                      _vm._v(" " + _vm._s(_vm.detail.failedAttempts) + " "),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-date" }),
                        _vm._v(" Last Login "),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm
                              .dayjs(_vm.detail.lastLoginAt)
                              .local()
                              .format("YYYY-MM-DD HH:mm:ss")
                          ) +
                          " "
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-date" }),
                        _vm._v(" Created At "),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm
                              .dayjs(_vm.detail.createdAt)
                              .local()
                              .format("YYYY-MM-DD HH:mm:ss")
                          ) +
                          " "
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 3 } },
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-date" }),
                        _vm._v(" Updated At "),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm
                              .dayjs(_vm.detail.updatedAt)
                              .local()
                              .format("YYYY-MM-DD HH:mm:ss")
                          ) +
                          " "
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { span: 4 } },
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-date" }),
                        _vm._v(" Permissions "),
                      ]),
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.detail.permissions,
                            callback: function ($$v) {
                              _vm.$set(_vm.detail, "permissions", $$v)
                            },
                            expression: "detail.permissions",
                          },
                        },
                        _vm._l(_vm.wrapperPermissions, function (permission) {
                          return _c(
                            "el-checkbox",
                            {
                              key: permission.key,
                              attrs: { label: permission.key },
                            },
                            [_vm._v(_vm._s(permission.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    2
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }